import { ChangeDetectionStrategy, Component, input, signal, output } from '@angular/core';
import { Icon, IconComponent } from '@circlek-global/lds-components';

@Component({
  selector: 'lds-accordion-item',
  templateUrl: './accordion-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
})
export class AccordionItemComponent {
  readonly title = input.required<string>();
  readonly panelIcon = input.required<Icon>();
  readonly isOpened = output<boolean>();
  readonly isActive = signal<boolean>(false);
  protected readonly Icon = Icon;

  toggleIsActive(): void {
    this.isActive.update((prevIsActive) => !prevIsActive);
    this.isOpened.emit(this.isActive());
  }
}
